import { createAction, props } from '@ngrx/store';
import { AssignmentConfigurationSummary } from 'src/app/shared/models/assignment-configuration-summary.model';
import { ContractAssignmentSummary } from 'src/app/shared/models/contract-assignment-summary.model';
import { AssigneeRoleType } from 'src/app/shared/models/enums/assignee-role-type.enum';
import { KeyValue } from 'src/app/shared/models/key-value.model';
import { Lookup } from 'src/app/shared/models/lookup.model';
import {
    BulkUnassignAssignmentChange,
    BulkUserAssignmentChange,
    UserAssignmentChange
} from 'src/app/shared/models/user-assignment-change-request.model';
import { ComplianceReportPermissionsDto } from '../../api/models/compliance-report-permissions-dto.model';
import { CompliancePermissions } from '../../models/compliance.permissions';
export const loadCompliancePermissionsFromQMAssociation = createAction('[QM Assocciation] Load Compliance Permissions');
export const loadCompliancePermissionsFromTeamInfo = createAction('[TEAM INFO COMPONENT] Load Compliance Permissions');
export const loadCompliancePermissionsSuccessfully = createAction(
    '[COMPLIANCE REPORT PERMISSIONS API] Load Compliance Permissions Successfully',
    props<{ permissions: ComplianceReportPermissionsDto }>()
);
export const loadCompliancePermissionsFailure = createAction(
    '[COMPLIANCE REPORT PERMISSIONS API] Failed To Load Compliance Permissions',
    props<{ error: unknown }>()
);

export const loadCompliancePermissionsWorkingListGrid = createAction(
    '[WORKINGLIST GRID COMPONENT] Load Compliance Permissions'
);
export const loadCompliancePermissionsFromPrestartGrid = createAction(
    '[PRESTART GRID COMPONENT] Load Compliance Permissions'
);
export const loadCredentialingSpecialistsFromPrestartGrid = createAction(
    '[PRESTART GRID COMPONENT] Load Credentialing Specialists'
);
export const loadCredentialingSpecialistsFromReassignDialog = createAction(
    '[REASSIGN CRED SPECIALIST DIALOG COMPONENT] Load Credentialing Specialists'
);
export const loadCredentialingSpecialistsFromCSEdit = createAction(
    '[CREDENTIALING SPECIALIST EDIT COMPONENT] Load Credentialing Specialists'
);
export const loadCredentialingSpecialistsFromFacilityContracts = createAction(
    '[FACILITY CONTRACTS GRID COMPONENT] Load Credentialing Specialists'
);

export const loadCredentialingSpecialistsSuccessfully = createAction(
    '[CREDENTIALING SPECIALISTS API] Load Credentialing Specialists Successfully',
    props<{ credentialingSpecialists: Lookup[] }>()
);
export const loadCredentialingSpecialistsFailure = createAction(
    '[CREDENTIALING SPECIALISTS API] Load Credentialing Specialists Failure',
    props<{ error: unknown }>()
);

export const filterCredentialingSpecialists = createAction(
    '[COMPLIANCE FACILITIES GRID COMPONENT] Filter Credentialing Specialists',
    props<{ filterVal: string }>()
);

export const updateCredentialingSpecialistFromPrestartGrid = createAction(
    '[PRESTART GRID COMPONENT] Update Credentialing Specialist',
    props<{ contractId: number; assignmentChange: UserAssignmentChange }>()
);
export const loadCompliancePermissionsFromCSEdit = createAction(
    '[CREDENTIALING SPECIALIST EDIT COMPONENT] Load Compliance Permissions From Compliance Report'
);
export const loadCompliancePermissionFromFacilityTab = createAction(
    '[FACILITY PROFILE COMPLIANCE CREDENTIALING COMPONENT] Load Compliance Permissions From Facility Profile'
);
export const loadCompliancePermissionFromQmAssociationDetails = createAction(
    '[QM ASSOCIATION DETAILS COMPONENT] Load Compliance Permissions from QM Associations Details'
);
export const loadCompliancePermissionFromPartnerNetworkSubcontractorGrid = createAction(
    '[PARTNER NETWORK SUBCONTRACTOR COMPONENT] Load Compliance Permissions From Partner Network Subcontractor Grid'
);
export const loadCompliancePermissionFromRecruitingCandidates = createAction(
    '[RECRUITING CANDIDATES COMPONENT] Load Compliance Permissions From Recruiting Candidates'
);
export const updateContractCredentialingSpecialist = createAction(
    '[CREDENTIALING SPECIALIST EDIT COMPONENT] Update Contract Credentialing Specialist',
    props<{ contractId: number; assignmentChange: UserAssignmentChange }>()
);

export const updateCandidateCredentialingSpecialistFromTeamInfo = createAction(
    '[TEAM INFO COMPONENT] Update Candidate Credentialing Specialist',
    props<{ candidateId: number; assignmentChange: UserAssignmentChange }>()
);

export const updateCandidateCredentialingSpecialistSuccessfully = createAction(
    '[CONTRACT ASSIGNMENTS API] Update Candidate Credentialing Specialist Successfully',
    props<{ candidateId: number }>()
);
export const updateCandidateCredentialingSpecialistFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Update Candidate Credentialing Specialist Failure',
    props<{ error: unknown }>()
);

export const updateContractCredentialingSpecialistSuccessfully = createAction(
    '[CONTRACT ASSIGNMENTS API] Update Contract Credentialing Specialist Successfully',
    props<{ res: unknown }>()
);
export const updateContractCredentialingSpecialistFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Update Contract Credentialing Specialist Failure',
    props<{ error: unknown }>()
);

export const loadContractAssignmentByContractId = createAction(
    '[COMPLIANCE REPORT COMPONENT] Load Contract Assignment By Contract Id',
    props<{ contractId: number }>()
);
export const loadContractAssignmentByContractIdFromCSEdit = createAction(
    '[CREDENTIALING SPECIALIST EDIT COMPONENT] Load Contract Assignment By Contract Id',
    props<{ contractId: number }>()
);

export const loadContractAssignmentByContractIdSuccessfully = createAction(
    '[CONTRACT ASSIGNMENTS API] Load Contract Assignment By Contract Id Successfully',
    props<{ assignment: ContractAssignmentSummary[] }>()
);
export const loadContractAssignmentByContractIdFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Load Contract Assignment By Contract Id Failure',
    props<{ error: unknown }>()
);

export const loadFacilityAssignmentByFacilityId = createAction(
    '[FACILITY PROFILE COMPLIANCE CREDENTIALING COMPONENT] Load Facility Assignment by Facility Id',
    props<{ facilityId: number; assigneeRole: AssigneeRoleType }>()
);

export const loadFacilityAssignmentByFacilityIdSuccessfully = createAction(
    '[CONTRACT ASSIGNMENTS API] Load Facility Assignment By Facility Id Successfully',
    props<{ assignment: AssignmentConfigurationSummary }>()
);
export const loadFacilityAssignmentByFacilityIdFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Load Facility Assignment By Facility Id Failure',
    props<{ error: unknown }>()
);

export const updateFacilityAssignmentByFacilityId = createAction(
    '[FACILITY PROFILE COMPLIANCE CREDENTIALING COMPONENT] Update Facility Assignment by Facility Id',
    props<{ facilityId: number; assignment: UserAssignmentChange }>()
);

export const updateFacilityAssignmentByFacilityIdSuccessfully = createAction(
    '[CONTRACT ASSIGNMENTS API] Update Facility Assignment By Facility Id Successfully',
    props<{ facilityId: number; assigneeRole: AssigneeRoleType }>()
);
export const updateFacilityAssignmentByFacilityIdFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Update Facility Assignment By Facility Id Failure',
    props<{ error: unknown }>()
);

export const loadLiaisonFacilityAssignmentByFacilityId = createAction(
    '[FACILITY PROFILE COMPLIANCE CREDENTIALING COMPONENT] Load Compliance Liaison Facility Assignment by Facility Id',
    props<{ facilityId: number; assigneeRole: AssigneeRoleType }>()
);

export const loadLiaisonFacilityAssignmentByFacilityIdSuccessfully = createAction(
    '[CONTRACT ASSIGNMENTS API] Load Compliance Liaison Facility Assignment By Facility Id Successfully',
    props<{ assignment: AssignmentConfigurationSummary }>()
);

export const loadLiaisonFacilityAssignmentByFacilityIdFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Load Compliance Liaison Facility Assignment By Facility Id Failure',
    props<{ error: unknown }>()
);

export const unassignCredentialingSpecialistFromCSEditReport = createAction(
    '[CRENTIALING SPECIALIST EDIT COMPONENT] Unassign Credential Specialist From CS Edit Report',
    props<{ bulkUnassignAssignment: BulkUnassignAssignmentChange }>()
);

export const unassignCredentialingSpecialistFromCSEditReportSuccess = createAction(
    '[CONTRACT ASSIGNMENTS API] Unassign Credential Specialist From CS Edit Report Success',
    props<{ id: number }>()
);

export const unassignCredentialingSpecialistFromCSEditReportFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Unassign Credential Specialist From CS Edit Report Failure',
    props<{ error: unknown }>()
);

export const unassignCredentialingSpecialistFromFacilityProfile = createAction(
    '[FACILITY PROFILE COMPLIANCE CREDENTIALING COMPONENT] Unassign Credential Specialist From Facility Profile',
    props<{ bulkUnassignAssignment: BulkUnassignAssignmentChange }>()
);

export const unassignCredentialingSpecialistFromFacilityProfileSuccess = createAction(
    '[CONTRACT ASSIGNMENTS API] Unassign Credential Specialist From Facility Profile Success',
    props<{ id: number }>()
);

export const unassignCredentialingSpecialistFromFacilityProfileFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Unassign Credential Specialist From Facility Profile Failure',
    props<{ error: unknown }>()
);

export const unassignComplianceLiaisonFromFacilityProfile = createAction(
    '[FACILITY PROFILE COMPLIANCE CREDENTIALING COMPONENT] Unassign Compliance Liaison From Facility Profile',
    props<{ bulkUnassignAssignment: BulkUnassignAssignmentChange }>()
);

export const unassignComplianceLiaisonFromFacilityProfileSuccess = createAction(
    '[CONTRACT ASSIGNMENTS API] Unassign Compliance Liaison From Facility Profile Success',
    props<{ id: number }>()
);

export const unassignComplianceLiaisonFromFacilityProfileFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Unassign Compliance Liaison From Facility Profile Failure',
    props<{ error: unknown }>()
);

export const unassignComplianceLiaisonFromAssociationProfile = createAction(
    '[QM ASSOCIATION PROFILE COMPLIANCE CREDENTIALING COMPONENT] Unassign Compliance Liaison From QM Association Profile',
    props<{ bulkUnassignAssignment: BulkUnassignAssignmentChange }>()
);

export const unassignComplianceLiaisonFromAssociationProfileSuccess = createAction(
    '[CONTRACT ASSIGNMENTS API] Unassign Compliance Liaison From QM Association Profile Success',
    props<{ id: number }>()
);

export const unassignComplianceLiaisonFromAssociationProfileFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Unassign Compliance Liaison From QM Association Profile Failure',
    props<{ error: unknown }>()
);

export const updateLiaisonFacilityAssignmentByFacilityId = createAction(
    '[FACILITY PROFILE COMPLIANCE CREDENTIALING COMPONENT] Update Compliance Liaison Facility Assignment by Facility Id',
    props<{ facilityId: number; assignment: UserAssignmentChange }>()
);

export const updateLiaisonFacilityAssignmentByFacilityIdSuccessfully = createAction(
    '[CONTRACT ASSIGNMENTS API] Update Compliance Liaison Facility Assignment By Facility Id Successfully',
    props<{ facilityId: number; assigneeRole: AssigneeRoleType }>()
);

export const updateLiaisonFacilityAssignmentByFacilityIdFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Update Compliance Liaison Facility Assignment By Facility Id Failure',
    props<{ error: unknown }>()
);

export const loadLiaisonQmAssociationAssignmentByAssociationId = createAction(
    '[FACILITY PROFILE COMPLIANCE CREDENTIALING COMPONENT] Load Qm Assocation Assignment By Association Id',
    props<{ associationId: number; assigneeRole: AssigneeRoleType }>()
);

export const loadLiaisonQmAssociationAssignmentByAssociationIdSuccessfully = createAction(
    '[CONTRACT ASSIGNMENTS API] Load Qm Assocation Assignment By Association Id Successfully',
    props<{ assignment: AssignmentConfigurationSummary }>()
);

export const loadLiaisonQmAssociationAssignmentByAssociationIdFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Load Qm Assocation Assignment By Association Id Failure',
    props<{ error: unknown }>()
);

export const updateLiaisonQmAssociationAssignmentByAssociationId = createAction(
    '[FACILITY PROFILE COMPLIANCE CREDENTIALING COMPONENT] Update Qm Assocation Assignment By Association Id',
    props<{ associationId: number; assignment: UserAssignmentChange }>()
);

export const updateLiaisonQmAssociationAssignmentByAssociationIdSuccessfully = createAction(
    '[CONTRACT ASSIGNMENTS API] Update Qm Assocation Assignment Assignment By Association Id Successfully',
    props<{ associationId: number; assigneeRole: AssigneeRoleType }>()
);

export const updateLiaisonQmAssociationAssignmentByAssociationIdFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Update Qm Assocation Assignment By Association Id Failure',
    props<{ error: unknown }>()
);

export const bulkUnassignCredentialingSpecialist = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Unassign Credentialing Specialist',
    props<{ bulkUnassignAssignment: BulkUnassignAssignmentChange }>()
);

export const bulkUnassignCredentialingSpecialistSuccess = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Unassign Credentialing Specialist Success'
);

export const bulkUnassignCredentialingSpecialistFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Unassign Credentialing Specialist Failure',
    props<{ error: unknown }>()
);

export const bulkUnassignCredentialingSpecialistFromFacilityGrid = createAction(
    '[FACILITIES GRID COMPONENT] Bulk Unassign Credentialing Specialist From Facility Grid',
    props<{ bulkUnassignAssignment: BulkUnassignAssignmentChange }>()
);

export const bulkUnassignCredentialingSpecialistFromFacilityGridSuccess = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Unassign Credentialing Specialist From Facility Grid Success'
);

export const bulkUnassignCredentialingSpecialistFromFacilityGridFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Unassign Credentialing Specialist From Facility Grid Failure',
    props<{ error: unknown }>()
);

export const bulkUpdateCredentialingSpecialistFromFacilityGrid = createAction(
    '[FACILITIES GRID COMPONENT] Bulk Update Credentialing Specialist From Facility Grid',
    props<{ bulkAssignment: BulkUserAssignmentChange }>()
);

export const bulkUpdateCredentialingSpecialistFromFacilityGridSuccess = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Update Credentialing Specialist From Facility Grid Success'
);

export const bulkUpdateCredentialingSpecialistFromFacilityGridFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Update Credentialing Specialist From Facility Grid Failure',
    props<{ error: unknown }>()
);

export const bulkUnassignCredentialingSpecialistFromRecruitingCandidatesGrid = createAction(
    '[RECRUITING CANDIDATES GRID] Bulk Unassign Credentialing Specialist From Recruiting Candidates Grid',
    props<{ bulkUnassignAssignment: BulkUnassignAssignmentChange }>()
);

export const bulkUnassignCredentialingSpecialistFromRecruitingCandidatesGridSuccess = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Unassign Credentialing Specialist From Recruiting Candidates Grid Success'
);

export const bulkUnassignCredentialingSpecialistFromRecruitingCandidatesGridFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Unassign Credentialing Specialist From Recruiting Candidates Grid Failure',
    props<{ error: unknown }>()
);

export const bulkUpdateCredentialingSpecialistFromRecruitingCandidatesGrid = createAction(
    '[RECRUITING CANDIDATES GRID COMPONENT] Bulk Update Credentialing Specialist From Recruiting Candidates Grid',
    props<{ bulkAssignment: BulkUserAssignmentChange }>()
);

export const bulkUpdateCredentialingSpecialistFromRecruitingCandidatesGridSuccess = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Update Credentialing Specialist From Recruiting Candidates Grid Success'
);

export const bulkUpdateCredentialingSpecialistFromRecruitingCandidatesGridFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Update Credentialing Specialist From Recruiting Candidates Grid Failure',
    props<{ error: unknown }>()
);

export const bulkUpdateCredentialingSpecialist = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Update Credentialing Specialist',
    props<{ bulkAssignment: BulkUserAssignmentChange }>()
);

export const bulkUpdateCredentialingSpecialistSuccess = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Update Credentialing Specialist Success'
);

export const bulkUpdateCredentialingSpecialistFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Update Credentialing Specialist Failure',
    props<{ error: unknown }>()
);

export const getCompliancePermissions = createAction('[Compliance Module] Get Compliance Permissions');

export const getCompliancePermissionsSuccess = createAction(
    '[Compliance API] Get Compliance Permissions Success',
    props<{ compliancePermissions: CompliancePermissions }>()
);

export const getCompliancePermissionsFailure = createAction(
    '[Compliance API] Get Compliance Permissions Failure',
    props<{ error: any }>()
);

export const bulkUnassignComplianceLiaisonFromFacilityGrid = createAction(
    '[FACILITIES GRID COMPONENT] Bulk Unassign Compliance Liaison from Facility Grid',
    props<{ bulkUnassignAssignment: BulkUnassignAssignmentChange }>()
);

export const bulkUnassignComplianceLiaisonFromFacilityGridSuccess = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Unassign Compliance Liaison from Facility Grid Success'
);

export const bulkUnassignComplianceLiaisonFromFacilityGridFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Unassign Compliance Liaison from Facility Grid Failure',
    props<{ error: unknown }>()
);

export const bulkUpdateComplianceLiaisonFromFacilityGrid = createAction(
    '[FACILITIES GRID COMPONENT] Bulk Update Compliance Liaison from Facility Grid',
    props<{ bulkAssignment: BulkUserAssignmentChange }>()
);

export const bulkUpdateComplianceLiaisonFromFacilityGridSuccess = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Update Compliance Liaison from Facility GridSuccess'
);

export const bulkUpdateComplianceLiaisonFromFacilityGridFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Update Compliance Liaison from Facility GridFailure',
    props<{ error: unknown }>()
);

export const loadCompliancePermissionsFromCLEdit = createAction(
    '[COMPLIANCE LIAISON EDIT COMPONENT] Load Compliance Permissions From Compliance Report'
);
export const loadComplianceLiaisonsFromCLEdit = createAction(
    '[COMPLIANCE LIAISON EDIT COMPONENT] Load Compliance Liaisons From Compliance Report'
);
export const loadComplianceLiaisonsSuccessfully = createAction(
    '[COMPLIANCE LIAISONS API] Load Compliance Liaisons Successfully',
    props<{ complianceLiaisons: KeyValue<number, string>[] }>()
);
export const loadComplianceLiaisonsFailure = createAction(
    '[COMPLIANCE LIAISONS API] Load Compliance Liaisons Failure',
    props<{ error: unknown }>()
);
export const loadContractAssignmentByContractIdFromCLEdit = createAction(
    '[COMPLIANCE LIAISON EDIT COMPONENT] Load Contract Assignment By Contract Id',
    props<{ contractId: number }>()
);
export const updateContractComplianceLiaison = createAction(
    '[COMPLIANCE LIAISON EDIT COMPONENT] Update Contract Compliance Liaison',
    props<{ contractId: number; assignmentChange: UserAssignmentChange }>()
);
export const updateContractComplianceLiaisonSuccessfully = createAction(
    '[CONTRACT ASSIGNMENTS API] Update Contract Compliance Liaison Successfully',
    props<{ res: unknown }>()
);
export const updateContractComplianceLiaisonFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Update Contract Compliance Liaison Failure',
    props<{ error: unknown }>()
);

export const unassignComplianceLiaisonFromCLEditReport = createAction(
    '[COMPLIANCE LIAISON EDIT COMPONENT] Unassign Compliance Liaison From CL Edit Report',
    props<{ bulkUnassignAssignment: BulkUnassignAssignmentChange }>()
);
export const unassignComplianceLiaisonFromCLEditReportSuccessfully = createAction(
    '[CONTRACT ASSIGNMENTS API] Unassign Compliance Liaison From CL Edit Report Success',
    props<{ id: number }>()
);
export const unassignComplianceLiaisonFromCLEditReportFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Unassign Compliance Liaison From CL Edit Report Failure',
    props<{ error: unknown }>()
);
